import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Copy, ExternalLink, Play, Share2, BookOpen, Video, Heart } from "lucide-react";
import { toast } from "sonner";
import { useState } from "react";

const CanalOracao = () => {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    toast.success("Link copiado para a área de transferência!");
    setTimeout(() => setCopied(null), 2000);
  };

  const salmos = [
    {
      numero: 23,
      titulo: "O Senhor é meu pastor",
      link: "https://rumble.com/c/c-3001464",
      descricao: "O Senhor é meu pastor, nada me faltará."
    },
    {
      numero: 91,
      titulo: "Aquele que habita no esconderijo do Altíssimo",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Aquele que habita no esconderijo do Altíssimo, à sombra do Onipotente descansará."
    },
    {
      numero: 103,
      titulo: "Bendize, ó minha alma, ao Senhor",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Bendize, ó minha alma, ao Senhor, e tudo o que há em mim bendiga o seu santo nome."
    },
    {
      numero: 121,
      titulo: "Elevo os meus olhos para os montes",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Elevo os meus olhos para os montes; de onde me virá o socorro?"
    },
    {
      numero: 150,
      titulo: "Louvai ao Senhor",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Louvai ao Senhor. Louvai a Deus no seu santuário; louvai-o no firmamento do seu poder."
    },
    {
      numero: 1,
      titulo: "Bem-aventurado o homem",
      link: "https://rumble.com/c/c-3001464",
      descricao: "Bem-aventurado o homem que não anda no conselho dos ímpios."
    }
  ];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Canal de Oração - Salmos
          </h1>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Um espaço dedicado à oração, meditação e reflexão através dos Salmos.
          </p>
        </div>

        <div className="mb-12">
          <Card className="overflow-hidden border border-border">
            <CardHeader className="bg-muted/50">
              <CardTitle className="text-xl flex items-center">
                <BookOpen className="mr-2 h-5 w-5 text-primary" /> Canal de Oração no Rumble
              </CardTitle>
              <CardDescription>
                Momentos de reflexão e oração através dos Salmos
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="flex flex-col gap-4">
                <p className="text-muted-foreground">
                  O Canal de Oração traz leituras dos Salmos e momentos de reflexão para fortalecer sua vida de oração. Um espaço para encontrar paz e conexão espiritual através das escrituras sagradas. Acompanhe nossas publicações semanais.
                </p>
                <div className="flex flex-wrap gap-4 items-center justify-between">
                  <Button 
                    asChild 
                    className="bg-primary hover:bg-primary/90 text-primary-foreground"
                  >
                    <a 
                      href="https://rumble.com/c/c-3001464" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <Video className="mr-2 h-5 w-5" /> Visitar Canal de Oração
                    </a>
                  </Button>
                  <Button 
                    variant="outline" 
                    onClick={() => handleCopy("https://rumble.com/c/c-3001464")}
                    className={copied === "https://rumble.com/c/c-3001464" ? "bg-primary/10" : ""}
                  >
                    <Copy size={16} className="mr-1" /> 
                    {copied === "https://rumble.com/c/c-3001464" ? "Copiado!" : "Copiar Link"}
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mb-12">
          <h2 className="text-2xl font-semibold mb-6">Salmos em Destaque</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {salmos.map((salmo, index) => (
              <Card key={index} className="overflow-hidden border border-border h-full flex flex-col">
                <CardHeader className="bg-muted/50">
                  <CardTitle className="text-lg flex items-center">
                    <Heart className="mr-2 h-4 w-4 text-primary" /> Salmo {salmo.numero}
                  </CardTitle>
                  <CardDescription>{salmo.titulo}</CardDescription>
                </CardHeader>
                <CardContent className="pt-6 flex-grow">
                  <p className="text-muted-foreground">
                    {salmo.descricao}
                  </p>
                </CardContent>
                <CardFooter className="flex justify-between">
                  <Button 
                    asChild 
                    variant="default"
                    size="sm"
                  >
                    <a 
                      href={salmo.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                    >
                      <Play size={16} className="mr-1" /> Ouvir Salmo
                    </a>
                  </Button>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => handleCopy(salmo.link)}
                    className={copied === salmo.link ? "bg-primary/10" : ""}
                  >
                    <Share2 size={16} className="mr-1" /> 
                    {copied === salmo.link ? "Copiado!" : "Compartilhar"}
                  </Button>
                </CardFooter>
              </Card>
            ))}
          </div>
        </div>

        <div className="mb-12">
          <Card className="overflow-hidden border border-border">
            <CardHeader className="bg-muted/50">
              <CardTitle className="text-xl">NOS TRILHOS DO SENHOR</CardTitle>
              <CardDescription>Uma jornada completa nos caminhos do Senhor</CardDescription>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="md:w-1/3 aspect-video overflow-hidden bg-muted rounded-lg">
                  <img 
                    src="https://sp.rmbl.ws/s8/6/S/U/q/i/SUqii.OvCc.jpg" 
                    alt="NOS TRILHOS DO SENHOR COMPLETAO.mp4"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="md:w-2/3">
                  <p className="text-muted-foreground mb-4">
                    O vídeo "NOS TRILHOS DO SENHOR" é uma reflexão profunda sobre nossa jornada espiritual. Assim como um trem segue fielmente seus trilhos, somos convidados a seguir o caminho do Senhor com fidelidade e determinação.
                  </p>
                  <p className="text-muted-foreground mb-4">
                    Esta meditação nos lembra que, mesmo quando o caminho parece difícil ou incerto, os trilhos do Senhor nos levam com segurança ao nosso destino. Uma mensagem de esperança e perseverança para todos os crentes.
                  </p>
                  <div className="flex flex-wrap gap-4 mt-4">
                    <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                      <a 
                        href="https://rumble.com/v6sl2ud-nos-trilhos-do-senhor-completao.mp4.html?e9s=src_v1_ucp" 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        <Play size={16} className="mr-1" /> Assistir Agora
                      </a>
                    </Button>
                    <Button 
                      variant="outline" 
                      onClick={() => handleCopy("https://rumble.com/v6sl2ud-nos-trilhos-do-senhor-completao.mp4.html?e9s=src_v1_ucp")}
                      className={copied === "https://rumble.com/v6sl2ud-nos-trilhos-do-senhor-completao.mp4.html?e9s=src_v1_ucp" ? "bg-primary/10" : ""}
                    >
                      <Share2 size={16} className="mr-1" /> 
                      {copied === "https://rumble.com/v6sl2ud-nos-trilhos-do-senhor-completao.mp4.html?e9s=src_v1_ucp" ? "Copiado!" : "Compartilhar"}
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="bg-muted p-6 rounded-lg mb-12">
          <h2 className="text-2xl font-semibold mb-4">O Poder da Oração</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-card p-4 rounded-lg border border-border">
              <h3 className="text-lg font-medium mb-2">Comunicação com Deus</h3>
              <p className="text-sm text-muted-foreground">A oração é nossa linha direta de comunicação com Deus, permitindo que expressemos nossos sentimentos e necessidades.</p>
            </div>
            <div className="bg-card p-4 rounded-lg border border-border">
              <h3 className="text-lg font-medium mb-2">Fortalecimento Espiritual</h3>
              <p className="text-sm text-muted-foreground">Através da oração regular, fortalecemos nossa fé e desenvolvemos uma relação mais profunda com o Senhor.</p>
            </div>
            <div className="bg-card p-4 rounded-lg border border-border">
              <h3 className="text-lg font-medium mb-2">Paz Interior</h3>
              <p className="text-sm text-muted-foreground">A oração nos proporciona paz interior e serenidade, mesmo em tempos de turbulência e incerteza.</p>
            </div>
          </div>
        </div>

        <div className="mb-12">
          <Card className="overflow-hidden border border-border">
            <CardHeader className="bg-muted/50">
              <CardTitle className="text-xl">Como Usar Nosso Canal para Sua Devoção Diária</CardTitle>
            </CardHeader>
            <CardContent className="pt-6">
              <ol className="list-decimal pl-5 space-y-4 text-muted-foreground">
                <li>
                  <strong className="text-foreground">Estabeleça um horário regular:</strong> Reserve um momento específico do seu dia para oração e meditação.
                </li>
                <li>
                  <strong className="text-foreground">Escolha um Salmo:</strong> Selecione um dos Salmos disponíveis em nosso canal que ressoe com seu momento atual.
                </li>
                <li>
                  <strong className="text-foreground">Prepare seu ambiente:</strong> Crie um ambiente tranquilo, livre de distrações para sua devoção.
                </li>
                <li>
                  <strong className="text-foreground">Ouça com atenção:</strong> Escute a leitura do Salmo com o coração aberto, permitindo que as palavras toquem sua alma.
                </li>
                <li>
                  <strong className="text-foreground">Reflita e ore:</strong> Após ouvir, reserve um tempo para reflexão pessoal e oração, aplicando as verdades à sua vida.
                </li>
                <li>
                  <strong className="text-foreground">Compartilhe a bênção:</strong> Se a mensagem tocou seu coração, compartilhe com amigos e familiares que possam se beneficiar.
                </li>
              </ol>
            </CardContent>
          </Card>
        </div>

        <div className="text-center">
          <Button 
            asChild 
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <a 
              href="https://rumble.com/c/c-3001464" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Inscreva-se no Canal de Oração
            </a>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CanalOracao;